import { useCallback } from 'react';
import { usePoDelivery } from '../usePurchaseOrderService';

export const usePoValidateDeliveryAddress = () => {
  const address = usePoDelivery();

  return useCallback<() => string>(() => {
    if (!address) {
      return 'Before moving to the confirm screen you must select a delivery address.';
    }

    return '';
  }, [address]);
};
